import './styles.css'
import store from 'shared/store/store'
import { createRoot } from 'react-dom/client'
import * as serviceWorker from './serviceWorker'
import history from 'browserHistory'
import { Provider } from 'react-redux'
import { setAxiosDefaults } from 'axiosConfig'
import { UserManager, UserManagerSettings } from 'oidc-client-ts'
import AppRoutes from 'App'
import { Router } from 'react-router-dom'
import { setReferrer } from 'shared/utils/referrer'
import { AuthProvider } from 'Auth/context/auth.context'
import { oidcConfig } from 'Auth/shared/constants/auth'
import { redirectWithUri } from 'Auth/shared/utils/redirectWithRedirectUrl'
import { LOCAL_STORAGE_REDIRECT_URL_LOGOUT } from 'shared/constants/localStorageVariables'
import { FeedbackProvider } from '@bbl-digital/snorre-v2'
import { initSentry } from '../sentry.js'

setAxiosDefaults()
setReferrer()
initSentry()

if (window.location.pathname.indexOf('/silentredirect') !== -1) {
  new UserManager({} as UserManagerSettings).signinSilentCallback().then()
} else if (localStorage.getItem(LOCAL_STORAGE_REDIRECT_URL_LOGOUT)) {
  // Redirect if we still hold a redirect url
  redirectWithUri()
} else {
  const container = document.getElementById('root')
  const root = createRoot(container!)

  root.render(
    <AuthProvider {...oidcConfig}>
      <FeedbackProvider>
        <Provider store={store}>
          <Router history={history}>
            <AppRoutes />
          </Router>
        </Provider>
      </FeedbackProvider>
    </AuthProvider>
  )
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
